import React from "react"
import { MenuItem } from "@mui/material"
import DropDownButton from "components/DropDownButton"
import typeImports from "./tipos/index"

export default function DropDownImports({ change, setLoadingCSV, navigate, showSuccess }) {
    return (
        <div>
            <DropDownButton color="primary" label="Import">
                {typeImports.map((importType, index) => {
                    return <MenuItem
                        key={index}
                        onClick={() => {
                            importType.nome === "(BETA) Importar Fazendas - RAA"
                                ? importType.importFile(change, setLoadingCSV, navigate, showSuccess)
                                : importType.importFile()
                        }}
                    >
                        {importType.nome}
                    </MenuItem>
                })}
            </DropDownButton>
        </div>
    );
}
